<template>
    <flat-pickr :config="config" :placeholder="placeholder" @on-change="onChange" :value="formattedValue"></flat-pickr>
</template>

<script>

import moment from 'moment';
import FlatPickr from 'vue-flatpickr-component/src/component';
import 'flatpickr/dist/flatpickr.css';

export default {

    props: {
        placeholder: { type: String, default: '' },
        format: { type: String, default: 'F j, Y' },
        apiFormat: { type: String, default: 'YYYY-MM-DD' },
        value: { type: String, default: '' },
        max: { default: undefined },
        min: { default: undefined },
        time: { type: Boolean, default: false },
        interval: { type: Number, default: 15 },
    },

    data() {
        let formattedValue = this.value;
        let momentDate = moment(formattedValue, this.apiFormat);
        if (momentDate.isValid()) {
            formattedValue = momentDate.format(this.format);
        }

        return {
            formattedValue,
            inputVal: formattedValue,
        };
    },

    computed: {

        config() {
            return {
                dateFormat: this.format,
            }
        },

    },

    methods: {

        onChange([ date ]) {
            this.inputVal = moment(date).format(this.apiFormat);
            this.onDateSelected(this.inputVal);
        },

        onDateSelected(newValue) {
            this.$emit('input', newValue);
        },

    },

    components: { FlatPickr },

}

</script>



// WEBPACK FOOTER //
// resources/js/components/elements/form/DatePicker.vue